var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.4 46.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30 32V20.1C30 13 24.3 7.3 17.2 7.3S4.4 13 4.4 20.1q0 0 0 0V32c-1.9.3-3.2 2.1-2.9 4 .3 1.7 1.8 3 3.5 3h24.4c1.9 0 3.5-1.5 3.6-3.4 0-1.8-1.3-3.3-3-3.6",
    className: "bell_svg__raw"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M23.6 38.9c0 3.5-2.9 6.4-6.4 6.4s-6.4-2.9-6.4-6.4M13.5 7.8V5.2c0-2 1.6-3.7 3.7-3.7h0c2 0 3.7 1.6 3.7 3.7v2.7",
    className: "bell_svg__raw"
  })));
};
export default SvgBell;